/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Moving_Bird_TransformInputs */

const fr_vivid_moving_bird_transform = /** @type {(inputs: Vivid_Moving_Bird_TransformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider`)
};

/**

* @param {Vivid_Moving_Bird_TransformInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vivid_moving_bird_transform = /** @type {((inputs?: Vivid_Moving_Bird_TransformInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Moving_Bird_TransformInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vivid_moving_bird_transform(inputs)
});